import React, { useEffect} from 'react';

import Loader from "../components/site/loader.js";
import Header from "../components/site/header.js";
import Footer from "../components/site/footer.js";
import Movies from "../components/movie/movies.js";


import CheckIfMobile from "../functions/checkmobile.js";

import { useCookies } from 'react-cookie';

//https://www.npmjs.com/package/react-cookie-consent


import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes, faSearch, faCheckCircle, faSpinner, faAngleDoubleRight} from '@fortawesome/free-solid-svg-icons';
import { faImdb , faGooglePlay, faAppStoreIos} from '@fortawesome/free-brands-svg-icons';
library.add(faTimes,faSearch, faCheckCircle, faSpinner, faAngleDoubleRight, faImdb, faGooglePlay, faAppStoreIos);




export default function Home() {
    const [cookies, setCookie] = useCookies(['user' , 'mood', 'genre']);

    useEffect(() => {
      if (typeof cookies.user == "undefined") {
        const userId = Math.floor((Math.random() * 1000000000)); 
        setCookie('user', userId, {path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + 7)), maxAge: 220898482  });
      }
      if (typeof cookies.mood == "undefined") {window.location = "/mood"; }

    }, [cookies.user , cookies.mood, cookies.genre, setCookie])

    return (
      <div className = "movieArc">
        <CheckIfMobile />
        <Header/>
        <Movies mood = {cookies.mood} genre = {cookies.genre}/>
        <Footer />
        <Loader />
      </div>
    )
}
     

